import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

import { getProfessione } from "../../functions/getProfessione";

import { Modal } from "@mui/material";
import { TextField } from "@mui/material";
import { InputAdornment } from "@mui/material";
import { Alert } from "@mui/material";

import SlideMainTitle from "../slides-components/Title";
import TitleDescription from "../slides-components/TitleDescription";

import ScontrinoWrapper from "../slides-components/ScontrinoWrapper";
import ScontrinoRowWrapper from "../slides-components/ScontrinoRowWrapper";
import ScontrinoFooter from "../slides-components/ScontrinoFooter";
import LabelValueRow from "../slides-components/LabelValueRow";

import Ricapitolando from "../slides-components/scontrino-widgets/Ricapitolando";
import SaveButton from "../slides-components/SaveButton";
import ContributiPrevidenzialiRouter from "../slides-components/scontrino-widgets/contributi/ContributiPrevidenzialiRouter";

import ImposteWidget from "../slides-components/scontrino-widgets/imposte/Imposte";

import TaxRate from "../slides-components/scontrino-widgets/tasse/TaxRate";
import TaxTotal from "../slides-components/scontrino-widgets/tasse/TaxTotal";

import YouTube from "@u-wave/react-youtube";

const Scontrino = ({ urlParameters }) => {
  const [fatturato, setFatturato] = useState(
    urlParameters.fatturato !== undefined ? urlParameters.fatturato : 10000
  );
  const [isOverForfettario, setIsOverForfettario] = useState(false);
  const [isSemplificato, setIsSemplificato] = useState(false);
  const [costiForfettariCoeff] = useState(
    100 - getProfessione(urlParameters.professione).redditivita
  );
  const [redditoPrevidenzialeCoeff] = useState(
    getProfessione(urlParameters.professione).redditivita
  );
  const [costiForfettari, setCostiForfettari] = useState();
  const [redditoPrevidenziale, setRedditoPrevidenziale] = useState();
  const [contributiTotali, setContributiTotali] = useState(0);
  const [imposteTotali, setimposteTotali] = useState(0);
  const [taxRateTotale, setTaxRateTotale] = useState(0);
  const [netto, setNetto] = useState(0);
  const [cassaCoeff, setCassaCoeff] = useState(10);
  const [ibridoCase, setIbridoCase] = useState(0);

  useEffect(() => {
    setCostiForfettari(fatturato * (costiForfettariCoeff / 100));
    setRedditoPrevidenziale(fatturato * (redditoPrevidenzialeCoeff / 100));
  }, [fatturato, costiForfettariCoeff, redditoPrevidenzialeCoeff]);

  const handleFatturatoChange = (event) => {
    setFatturato(event.target.value !== "" ? event.target.value : 0);
  };

  useEffect(() => {
    if (parseInt(fatturato) > 85000 && parseInt(fatturato) < 100000) {
      setIsOverForfettario(true);
      setIsSemplificato(false);
    } else if (parseInt(fatturato) > 99999) {
      setIsOverForfettario(false);
      setIsSemplificato(true);
    } else {
      setIsOverForfettario(false);
      setIsSemplificato(false);
    }
  }, [fatturato, setIsOverForfettario, setIsSemplificato]);

  const handleModalClose = () => {
    setIsSemplificato(true);
    setFatturato(10000);
  };
  return (
    <ScontrinoWrapper>
      <div className="pt-8 pb-8">
        <SlideMainTitle text={`Et voilà!  🎉`} />
        <TitleDescription text={"Prova ad inserire diversi fatturati"} />
      </div>
      <Ricapitolando
        parameters={urlParameters}
        fatturato={fatturato}
        contributi={contributiTotali}
        imposteTotali={imposteTotali}
        netto={netto}
      />
      <div
        style={{ border: "1px solid orange" }}
        className="shadow-xl bg-gray-50 flex items-start justify-center flex-col  p-[1em] md:p-4 mt-10 mb-10 sticky top-0 rounded-md z-10"
      >
        <div className="flex flex-col-reverse md:flex-row items-center justify-between w-full pb-4 gap-y-2">
          <span className="dark:text-gray-700 text-2xl md:text-4xl">
            Quanto pensi di fatturare?
          </span>
          <SaveButton
            fatturato={fatturato}
            cassaCoeff={cassaCoeff}
            ibridoCase={ibridoCase}
          />
        </div>

        <TextField
          variant="standard"
          fullWidth
          focused
          type="number"
          id="fatturato"
          name="fatturato"
          InputProps={{
            disableUnderline: true,
            startAdornment: <InputAdornment position="start">€</InputAdornment>,
            inputMode: "numeric",
            pattern: "[0-9]*",
            style: {
              backgroundColor: "white",
              border: "1px solid orange",
              padding: "1em",
              borderRadius: "3px",
            },
            sx: {
              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                border: "none!important",
                color: "orange",
              },
            },
            classes: {
              root: " dark:bg-gray-800 dark:text-black",
              focused: "border-none",
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root.Mui-focused": {
              "& > fieldset": { border: "1px solid orange" },
            },
          }}
          placeholder={String(fatturato)}
          value={String(fatturato)}
          InputLabelProps={{
            style: { color: "black", backgroundColor: "white" },
          }}
          onChange={(e) => handleFatturatoChange(e)}
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value))
              .toString()
              .slice(0, 12);
          }}
        />
        <div className="relative w-full flex">
          <AnimatePresence>
            {isOverForfettario && !isSemplificato && (
              <motion.div
                className="w-full mt-4"
                initial={{ opacity: 0, y: "-100%" }}
                animate={{ opacity: 1, y: "0" }}
                exit={{
                  opacity: 0,
                  y: "-100%",
                  position: "absolute",
                }}
              >
                <Alert severity="error">
                  Stai fatturando più di quanto è consentito nel regime
                  forfettario. <br />
                  Dall'anno successivo a quando fatturerai in eccedenza sarai
                  costretto ad abbandonare il regime forfettario.
                </Alert>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
      <Modal
        open={isSemplificato}
        onClose={() => handleModalClose()}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="h-full flex flex-col items-center justify-center"
      >
        <div className="p-4 my-24 py-6 md:py-12 rounded-md shadow-xl bg-gray-100 w-[85%] md:w-[70%] md:px-10 xl:px-20  dark:bg-gray-800 md:text-xl max-h-[80vh] overflow-scroll">
          <div className="pt-1 pb-2 md:pb-8">
            <h2 className="font-bold text-center text-md pb-0 md:pb-2 text-xl md:text-3xl">
              Stai fatturando più di 100 mila euro annuali
            </h2>
            <p class="text-center">
              Contattaci per valutare insieme l’adesione al regime semplificato
              ordinario
            </p>
          </div>
          <div className="flex flex-col items-center justify-center pb-8 md:pb-12">
            <button className="p-8 bg-orange-400 text-white rounded-md pt-2 pb-2 mt-3 duration-300 hover:shadow-xl">
              <a
                href="https://fidocommercialista.it/registrati/"
                target="_blank"
                rel="noreferrer"
                className="text-white text-sm md:text-xl"
              >
                Prenota una consulenza gratuita
              </a>
            </button>
            <span className="pt-2 text-gray-500 text-sm">
              Non è richiesta carta di credito
            </span>
          </div>
          <div className="video-container">
            <YouTube video="q_jRCzTNzAA" startSeconds={235} allowFullscreen />
          </div>
        </div>
      </Modal>
      {/* -------------------------------- */}
      {/* SECTION  1 */}
      <ScontrinoRowWrapper
        title={"Reddito Previdenziale"}
        tooltipText={"Fatturato * coefficiente di redditivtà"}
      >
        <LabelValueRow
          label={"Costi forfettari"}
          meta={`${costiForfettariCoeff}%`}
          value={`${costiForfettari}`}
        />
        <LabelValueRow
          label={"Reddito Previdenziale"}
          meta={`${redditoPrevidenzialeCoeff}%`}
          value={`${redditoPrevidenziale}`}
        />
      </ScontrinoRowWrapper>

      {/* -------------------------------- */}
      {/* SECTION  2 */}
      <ScontrinoRowWrapper title={"Contributi previdenziali e assistenziali"}>
        <ContributiPrevidenzialiRouter
          fatturato={fatturato}
          contributiCase={urlParameters.contributi}
          ibrido={urlParameters.ibrido}
          contributiTotali={contributiTotali}
          setContributiTotali={setContributiTotali}
          riduzioneContributi={urlParameters.riduzioneContributi}
          redditoPrevidenziale={redditoPrevidenziale}
          isFullTime={urlParameters.fullTime}
          gestionePrevidenziale={urlParameters.gestionePrevidenziale}
          cassaCoeff={cassaCoeff}
          setCassaCoeff={setCassaCoeff}
          parameters={urlParameters}
          setIbridoCase={setIbridoCase}
        />
      </ScontrinoRowWrapper>
      {/* -------------------------------- */}

      {/* -------------------------------- */}
      {/* SECTION  3 */}
      <ScontrinoRowWrapper
        title={"Imposta"}
        tooltipText={"Reddito previdenziale * aliquota d'imposta"}
      >
        <ImposteWidget
          contributiTotali={contributiTotali}
          riduzioneImposte={urlParameters.riduzioneImposte}
          setimposteTotali={setimposteTotali}
          imposteTotali={imposteTotali}
          redditoPrevidenziale={redditoPrevidenziale}
        />
      </ScontrinoRowWrapper>
      {/* -------------------------------- */}

      {/* -------------------------------- */}
      {/* SECTION  4 */}
      <ScontrinoRowWrapper>
        <TaxTotal
          fatturato={fatturato}
          taxRateTotale={taxRateTotale}
          netto={netto}
          setNetto={setNetto}
        />
      </ScontrinoRowWrapper>
      {/* -------------------------------- */}

      {/* -------------------------------- */}
      {/* SECTION  5 */}
      <ScontrinoRowWrapper title={"Tax rate"}>
        <TaxRate
          contributiTotali={contributiTotali}
          imposteTotali={imposteTotali}
          fatturato={fatturato}
          setTaxRateTotale={setTaxRateTotale}
          taxRateTotale={taxRateTotale}
        />
      </ScontrinoRowWrapper>
      {/* -------------------------------- */}

      <ScontrinoFooter
        gestionePrevidenziale={urlParameters.gestionePrevidenziale}
        ibridoCase={ibridoCase}
        parameters={urlParameters}
      />
    </ScontrinoWrapper>
  );
};

export default Scontrino;
